import { useMemo } from "react";
import JoinTable from "../../assets/join-table.png";
import Watch from "../../assets/watch.png";
import Start from "../../assets/start.png";
import PartyPopper from "../../assets/party-popper.png";
import { defaultDescription, defaultHeadline } from "../../constants";

export type Step = {
  title: string;
  image?: string;
  content?: string;
  button?: string;
  type?: string;
};

const useSteps = (): Step[] => {
  const STEPS = useMemo(
    () => [
      {
        title: defaultHeadline,
        image: PartyPopper,

        content: defaultDescription,
        button: "onboarding:awesome.begin",
      },
      {
        title: "onboarding:drag.map",
        image: JoinTable,
        content: "onboarding:navigate.event",
        button: "onboarding:button.next",
      },
      {
        title: "onboarding:watch.participate.live.event",
        image: Watch,
        content: "onboarding:screen.auto.broadcast",
        button: "onboarding:button.next",
      },
      {
        title: "TUTORIAL",
        type: "TUTORIAL",
      },
      {
        title: "onboarding:camera.shy",
        image: Start,
        content: "onboarding:keep.camera.mic.on",
        button: "onboarding:button.start.networking",
      },
    ],
    [],
  );

  return STEPS;
};

export default useSteps;
